import React from "react";

export interface NoDataFoundPropsI {
    svg?: any;
    heading: string;
    subHeading: any;
    supportingText?: string;
    buttonText?: string;
    showButton?: boolean;
    buttonClickHandler?: Function;
    sameasSubHeading?: boolean;
}

export const NoDataFound = ({
    buttonText = "",
    heading = "",
    subHeading = "",
    svg,
    showButton = false,
    buttonClickHandler = () => { },
    supportingText = "",
    sameasSubHeading,
}: NoDataFoundPropsI) => {
    return (
        <>
            <div className="empty-data tw-mb-8 mt-5">
                {svg ? <div className="empty-data-icon"> {svg} </div> : null}
                <div className="empty-data-details">
                    <div className="empty-data-h1">{heading} </div>
                    <p className="empty-data-text-2 !tw-text-[#616161] fs14">
                        {subHeading}
                    </p>
                    <p className="empty-data-text-2 !tw-text-[#616161] fs14">
                        {supportingText}
                    </p>
                    {showButton && (
                        <div>
                            <a
                                href={`/learning/home`}
                                // onClick={() => buttonClickHandler(true)}
                                className="button-primary"
                            >
                                {buttonText}
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};
